<template>
  <v-card>
    <v-card-title>
      {{$t('title')}}
      <v-spacer />
      <v-btn color="primary" small dense :to="{name: 'NewPurchase', query: { uuid: customer.uuid } }">{{$t('new')}}</v-btn>
    </v-card-title>

    <v-card-text>
      <v-simple-table v-if="purchases.length>0">
        <tbody>
          <tr v-for="purchase in purchases">
            <td class="text-left"><Time :time="purchase.createdAt" format="date" /></td>
            <td class="text-left">{{purchase.description}}</td>
            <td class="text-right"><NumberFormatter :value="purchase.quantity" unit="units" /></td>
            <td>
              <v-btn color="primary" text :to="{name: 'ShowPurchase', query: { uuid: purchase.customerUuid, purchaseUuid: purchase.uuid }}" class="ml-1">
                <v-icon dense>mdi-shopping-outline</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div v-else>
        {{$t('noPurchases')}}
      </div>
    </v-card-text>

  </v-card>
</template>


<script>
  import Time from '@/components/Time';
  import NumberFormatter from '@/components/NumberFormatter';

  export default {

    components: { Time, NumberFormatter },

    props: ['customer'],

    computed: {
      customerUuid() { return this.$route.query.uuid; },
      purchases() { return this.$store.getters.purchasesForCustomer(this.customerUuid).reverse().slice(0,5); },
    },

    methods: {
    },

  }
</script>


<i18n>
{
  "en": {
    "title": "Purchases",
    "noPurchases": "No purchases yet."
  },
  "es": {
    "title": "Compras",
    "noPurchases": "Sin compras todavía."
  },
  "sw": {
    "title": "Manunuzi",
    "noPurchases": "Hakuna ununuzi bado."
  }
}
</i18n>
